export const GET_PROJECTS = 'GET_PROJECTS';
export const SEND_EMAIL = 'SEND_EMAIL';
export const EMAIL_NOT_SENT = 'EMAIL_NOT_SENT';